import { render, staticRenderFns } from "./groupCalendarAFS.vue?vue&type=template&id=0370a375"
import script from "./groupCalendarAFS.vue?vue&type=script&lang=js"
export * from "./groupCalendarAFS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports